import type { TourDef } from '../types';

/** For admins: the Admin Center's areas, the Overview, Ctrl K and the quiet mode bubble. */
const admin: TourDef = {
  id: 'admin',
  version: 1,
  route: '/admin/overview',
  roles: ['admin'],
  steps: [
    { target: ['[data-tour="admin-nav"]', '[data-tour="admin-area-switch"]'], key: 'areas', padding: 0 },
    { target: '[data-tour="admin-attention"]', key: 'attention' },
    { target: ['[data-tour="admin-search"]', '[data-tour="admin-search-icon"]'], key: 'search' },
    // Shown only while quiet mode is on; otherwise the step is left out.
    { target: '[data-tour="quiet-mode-bubble"]', key: 'quiet' },
    { target: '[data-tour="help-button"]', key: 'help' },
  ],
};

export default admin;
